const locations = {
	Texas: {
		level: '12',
		description:
			'<div>I am located in DFW, Texas</div>' +
			'<div>I moved to the U.S. when I was 12 years old speaking little to no English.</div>' +
			'<div>I went to Arlington High School and became the President of the Engineering Club and Co-founder of Chess Club.</div>' +
			'<div>I graduated from the University of Texas at Arlington majoring in Computer Science Engineering.</div>' +
			'<div>I am currently a Software Developer at American Airlines focusing in cookies management.</div>' +
			"<div>I love to travel, so you'd probably see many location markers on the globe marking places I've been or wanting to visit</div>" +
			'<div>I am excited for what lies ahead!</div>',
		x: 32.7,
		y: 96.9,
	},

	California: {
		level: '8',
		description:
			'<div>My sister lives in California and I visit her often.</div>' +
			'<div>I also love to travel to California because of its weather. Cool and Chilling.</div>' +
			"<div>I've been to many part of California, my favorite places to go are Disneyland, Legoland, San Francisco, LA, and many more...</div>" +
			'<div>I am also open to relocate for work if nicely compensated.</div>',
		x: 39.3,
		y: 119,
	},

	Vietnam: {
		level: '0',
		description:
			'<div>I was born and raised in Vietnam up until I was 12 years old.</div>' +
			'<div>I only visited Vietnam once after I moved to the US, and it changed so much.</div>',
		x: 10.7,
		y: -106.7,
	},

	Arizona: {
		level: '24',
		description:
			'<div>Grand Canyon in Arizona is one of the best hiking spot I could find.</div>' +
			'<div>I went to the Grand Canyon for my graduation trip on August 2021.</div>' +
			'<div>My gf and dog loves to go hiking. It was tough carrying him on the way back though T.T</div>' +
			'<div>Activities: hiking, camping</div>',
		x: 36.1,
		y: 112.1,
	},

	'New Mexico': {
		level: '21',
		description:
			'<div>New Mexico has great Skiing slopes for beginners</div>' +
			'<div>It was where I first started to learn to Snowboard.</div>' +
			'<div>Activity: snowboarding</div>',
		x: 36.7,
		y: 105.4,
	},

	Colorado: {
		level: '22',
		description:
			'<div>Look at this great landscape. A beautiful place to go hiking and skiing</div>' +
			'<div>Activity: snowboarding</div>',
		x: 39.6,
		y: 105.8,
	},

	Florida: {
		level: '21',
		description:
			'<div>Wonder Works will make you dizzy. Overall a good experience exploring the museum.</div>' +
			'<div>Activity: swimming, museums, cooking</div>',
		x: 30.2,
		y: 85.8,
	},

	Nevada: {
		level: '23',
		description:
			'<div>I love to travel to Lake Tahoe, the weather there is very nice and cool.</div>' +
			'<div>When I went there, the forest was burning and I was driving in the middle of the fire</div>' +
			'<div>Activity: kayaking, swimming, casino, eating</div>',
		x: 39.1,
		y: 115,
	},

	Oklahoma: {
		level: '19',
		description:
			'<div>I love to travel Oklahoma City.</div>' +
			'<div>Activity: swimming, kyaking, exploring, downtown weekend music</div>',
		x: 35.5,
		y: 97.6,
	},

	Mexico: {
		level: '24',
		description:
			'<div>I love to travel Cancun, the culture is great and the food is even greater.</div>' +
			'<div>Activity: all inclusive park, swimming with turtles, eating Tacos everyday</div>',
		x: 21,
		y: 87.5,
	},
};

export default locations;
